var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriversEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 10,
    viewBox: "0 0 12.5 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,11a6.406,6.406,0,0,1,12.5,0A6.406,6.406,0,0,1,3,11Zm6.25,3.125A3.125,3.125,0,1,0,6.125,11,3.125,3.125,0,0,0,9.25,14.125Zm0-1.25A1.875,1.875,0,1,0,7.375,11,1.875,1.875,0,0,0,9.25,12.875Z",
    transform: "translate(-3 -6)",
    fill: "#0a76ae",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversEyeIcon);
export default __webpack_public_path__ + "static/media/drivers-eye-icon.73428007.svg";
export { ForwardRef as ReactComponent };